import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { Card, Button, Input, Modal, Table } from '../components/Common';

export default function GroupManagement() {
  const { apiFetch } = useAuth();
  const [groups, setGroups] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({});
  const [editing, setEditing] = useState(null);

  const load = useCallback(async () => {
    const res = await apiFetch('/groups');
    setGroups(await res.json());
  }, [apiFetch]);

  useEffect(() => { load(); }, [load]);

  const save = async () => {
    if (editing) {
      await apiFetch(`/groups/${editing.id}`, { method: 'PUT', body: JSON.stringify(form) });
    } else {
      await apiFetch('/groups', { method: 'POST', body: JSON.stringify(form) });
    }
    setShowModal(false); setForm({}); setEditing(null); load();
  };

  const del = async (id) => {
    if (!window.confirm('Delete this group?')) return;
    const res = await apiFetch(`/groups/${id}`, { method: 'DELETE' });
    if (!res.ok) { const d = await res.json(); alert(d.error); }
    load();
  };

  const columns = [
    { key: 'name', label: 'Name' },
    { key: 'description', label: 'Description' },
    { key: 'is_system', label: 'System', render: v => v ? '🔒 System' : 'Custom' },
    { key: 'id', label: 'Actions', render: (v, row) => !row.is_system ? (
      <div style={{ display: 'flex', gap: 8 }}>
        <Button variant="secondary" style={{ padding: '4px 12px', fontSize: 12 }}
          onClick={(e) => { e.stopPropagation(); setEditing(row); setForm({ name: row.name, description: row.description }); setShowModal(true); }}>Edit</Button>
        <Button variant="danger" style={{ padding: '4px 12px', fontSize: 12 }} onClick={(e) => { e.stopPropagation(); del(v); }}>Delete</Button>
      </div>
    ) : <span style={{ color: 'var(--text-secondary)', fontSize: 12 }}>Protected</span> }
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h1 style={{ fontSize: 24, fontWeight: 700 }}>Group Management</h1>
        <Button onClick={() => { setEditing(null); setForm({}); setShowModal(true); }}>+ New Group</Button>
      </div>
      <Table columns={columns} data={groups} />
      <Modal isOpen={showModal} onClose={() => setShowModal(false)} title={editing ? 'Edit Group' : 'New Group'} width={500}>
        <Input label="Name *" value={form.name || ''} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} />
        <Input label="Description" value={form.description || ''} onChange={e => setForm(f => ({ ...f, description: e.target.value }))} />
        <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', marginTop: 16 }}>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
          <Button onClick={save} disabled={!form.name}>Save</Button>
        </div>
      </Modal>
    </div>
  );
}
